<div class="form-check form-switch">
  <input type="checkbox" class="form-check-input" id="canCreateCompanies" [(ngModel)]="service.canCreateCompanies" name="canCreateCompanies" #canCreateCompanies="ngModel">
  <label for="canCreateCompanies" class="form-check-label">{{'SERVICE-CSV.CAN_CREATE_COMPANIES' | translate}}</label>
</div>

<div class="form-check form-switch">
  <input type="checkbox" class="form-check-input" id="isForPortal" [(ngModel)]="service.isForPortal" name="isForPortal">
  <label for="isForPortal" class="form-check-label">{{'PORTAL.PUBLISH_SERVICE' | translate}}</label>
</div>

<div class="form-group">
  <label for="defaultFileFormat">{{'SERVICE-CSV.DEFAULT_FILE_FORMAT' | translate}}</label>
  <select [(ngModel)]="service.defaultFileFormat" id="defaultFileFormat" class="form-control" name="defaultFileFormat" #defaultFileFormat="ngModel">
    @for (value of service.fileFormats; track value) {
      <option value="{{value['id']}}">
        {{value['name']}}
      </option>
    }
  </select>
</div>

<button type="button" class="btn btn-primary" style="float: right;" #newDataFormatBtn (click)="selectedFileFormat = null; lgModal.show();">{{'SERVICE-CSV.ADD_FORMAT' | translate}}
</button>
<br/>
<br/>


@for (value of service.fileFormats; track value) {
  <div class="accordion" style="margin-top: 10px; width: 100%;">
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button type="button" class="accordion-button" [class.collapsed]="!isFormatExpanded(value)"
          [style.border]="value['isForPortal'] ? '2px solid var(--success-bg)' : 'none'"
          (click)="toggleFormat(value)"
          [attr.aria-expanded]="isFormatExpanded(value)"
          [attr.aria-controls]="'collapseFormat_' + value['id']">
          {{value['name']}}
        </button>
      </h2>

      <div [id]="'collapseFormat_' + value['id']" class="accordion-collapse" [ngbCollapse]="!isFormatExpanded(value)">
        <div class="accordion-body">
        <button type="button" class="btn btn-primary" style="width: 50%; margin-top: 10px;" (click)="showFileFormat(value); lgModal.show();">
          {{value['name']}}
        </button>
        <button type="button" class="btn btn-primary" style=" margin-top: 10px;" (click)="lgModalUpload.show();">
          {{'SERVICE-CSV.UPLOAD_FILE' | translate}}
        </button>
        <div bsModal #lgModalUpload="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" [config]="{backdrop: 'static'}" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title pull-left">
                {{'SERVICE-CSV.UPLOAD_CSV_FILE' | translate}}</h4>
              </div>
              <div class="modal-body">
                <form method="post" enctype="multipart/form-data">
                  <div style="width:100%;">
                    <div class="form-group">
                      <input type="file" id="fileUploadService_{{value['id']}}" [disabled]="uploader.queue.length" #fileUpload class="form-control" name="single" ng2FileSelect [uploader]="uploader" />
                    </div>
                    <div>
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="50%">{{'SERVICE-CSV.NAME' | translate}}</th>
                            <th>{{'SERVICE-CSV.SIZE' | translate}}</th>
                            <th>{{'SERVICE-CSV.ACTIONS' | translate}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (item of uploader.queue; track item) {
                            <tr>
                              <td><strong>{{ item.file.name }}</strong></td>
                              <td nowrap>{{ item.file.size/1024/1024 | number:'.2' }} MB</td>
                              <td nowrap>
                                <button type="button" class="btn btn-danger btn-xs" (click)="clearSelectedFile();uploader.clearQueue()">
                                  <span class="glyphicon glyphicon-trash"></span> {{'SERVICE-CSV.REMOVE' | translate}}
                                </button>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                      <button type="button" class="btn btn-danger btn-s" (click)="this.fileFormatId=value['id']; uploader.uploadAll()" [disabled]="!uploader.queue.length">
                        <span class="glyphicon glyphicon-ok"></span> {{'SERVICE-CSV.UPLOAD' | translate}}
                      </button>
                      <button type="button" class="btn btn-warning btn-s" (click)="lgModalUpload.hide();clearSelectedFile();uploader.clearQueue()">
                        <span class="glyphicon glyphicon-ban-circle"></span> {{'SERVICE-CSV.CANCEL' | translate}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        @if (value['externalApiGateway'] && this.user?.roles?.includes('ADMIN')) {
          <button type="button" class="btn btn-primary" style=" margin-top: 10px;" (click)="fetchFromApi(value)" [disabled]="value['fetchingFromApi']">
            @if (value['fetchingFromApi']) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              <span role="status">Fetching...</span>
            }
            @if (!value['fetchingFromApi']) {
              {{'SERVICE-API.FETCH' | translate}}
            }
          </button>
        }
        @if (value['fusionImport'] && this.user?.roles?.includes('ADMIN')) {
          <button type="button" class="btn btn-primary" style=" margin-top: 10px;" (click)="fetchFromTas(value)">
            {{'SERVICE-CSV.FETCH' | translate}}
          </button>
        }
        <button type="button" class="btn btn-primary" style=" margin-top: 10px;" (click)="openModal(templateDuplicate)">
          {{'SERVICE-CSV.DUPLICATE' | translate}}
        </button>
        <button type="button" class="btn btn-primary" style="  margin-top: 10px;" (click)="openModal(template)">
          {{'SERVICE-CSV.DELETE' | translate}}
        </button>
        <ng-template #template>
          <div class="modal-body text-center">
            <p>{{'SERVICE-CSV.FORMAT_DELETE_CONFIRM' | translate}}</p>
            <button type="button" class="btn btn-outline-secondary" (click)="confirmDeletion(service.id, value['id']);">{{'SERVICE-CSV.YES' | translate}}
            </button>
            <button type="button" class="btn btn-primary" (click)="decline()">{{'SERVICE-CSV.NO' | translate}}</button>
          </div>
        </ng-template>
        <ng-template #templateDuplicate>
          <div class="modal-body text-center">
            <p>{{'SERVICE-CSV.INDICATE_NAME' | translate}}</p>
            <input #duplicateName type="text" class="form-control" id="duplicateName" name="duplicateName">
            <br/>
            <button type="button" class="btn btn-outline-secondary" (click)="confirmDuplication(value['id'], duplicateName.value);">{{'SERVICE-CSV.OK' | translate}}
            </button>
            <button type="button" class="btn btn-primary" (click)="decline()">{{'SERVICE-CSV.CANCEL' | translate}}</button>
          </div>
        </ng-template>

        <fieldset class="border rounded p-2 mt-2">
          <legend class="fs-6">{{'PORTAL.SECTION' | translate}}</legend>

          <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="ffPortal_{{value['id']}}"
              [(ngModel)]="value['isForPortal']" name="ffPortal_{{value['id']}}"
              (ngModelChange)="onPortalPublishToggle(value)">
            <label for="ffPortal_{{value['id']}}" class="form-check-label">{{'PORTAL.PUBLISH_DATASET' | translate}}</label>
          </div>

          @if (value['isForPortal']) {
            <div class="form-group mt-2">
              <label for="ffPortalCode_{{value['id']}}">{{'PORTAL.CODE' | translate}}</label>
              <input type="text" class="form-control" id="ffPortalCode_{{value['id']}}"
                [(ngModel)]="value['portalCode']" name="ffPortalCode_{{value['id']}}"
                #ffPortalCode="ngModel" required>
              <div [hidden]="ffPortalCode.valid || ffPortalCode.pristine" class="alert alert-danger py-1 px-2 mb-0 mt-1">
                {{'PORTAL.CODE_REQUIRED' | translate}}
              </div>
              <small class="form-text text-muted">{{'PORTAL.CODE_HINT' | translate}}</small>
            </div>

            <div class="form-group mt-2">
              <label for="ffPortalCat_{{value['id']}}">{{'PORTAL.CATEGORY' | translate}}</label>
              <select class="form-control" id="ffPortalCat_{{value['id']}}"
                [(ngModel)]="value['portalCategory']" name="ffPortalCat_{{value['id']}}">
                <option [ngValue]="null">{{'PORTAL.CATEGORY_NONE' | translate}}</option>
                @for (cat of portalCategories; track cat.key) {
                  <option [ngValue]="cat.key">{{cat.tag | translate}}</option>
                }
              </select>
            </div>

            <div class="form-group mt-2">
              <label for="ffPortalDesc_{{value['id']}}">{{'PORTAL.DESCRIPTION' | translate}}</label>
              <textarea class="form-control" id="ffPortalDesc_{{value['id']}}" rows="3" maxlength="2000"
                [(ngModel)]="value['portalDescription']" name="ffPortalDesc_{{value['id']}}"></textarea>
              <small class="form-text text-muted">
                {{ (value['portalDescription'] || '').length }}/2000 — {{'PORTAL.DESCRIPTION_HINT' | translate}}
              </small>
            </div>

            <p class="mb-1 mt-2">
              {{'PORTAL.PUBLISHED_COLUMNS' | translate}}:
              <strong>{{publishedColumnCount(value)}}</strong> / {{eligibleColumnCount(value)}}
              <small class="text-muted">— {{'PORTAL.COLUMNS_EDITED_IN_FORMAT' | translate}}</small>
            </p>

            @if (portalWarning(value)) {
              <div class="alert alert-warning py-1 px-2 mb-0">{{portalWarning(value) | translate}}</div>
            }
          }
        </fieldset>
        </div>
      </div>
    </div>
  </div>
}

<div bsModal #lgModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"  [config]="{backdrop: 'static'}" aria-hidden="true">
  <div class="modal-dialog modal-xl" style="width: 100%;">

    <div class="modal-content" style="padding: 10px;">
      <nav ngbNav class="nav-tabs" #nav="ngbNav" [destroyOnHide]="false" [activeId]="activeId">
        <ng-container [ngbNavItem]="1">
          <a ngbNavLink>
            CSV
          </a>
          <ng-template ngbNavContent>
            <div class="tab-pane" id="tab1" [class.active]="!selectedFileFormat || !selectedFileFormat['fusionImport']">
              <h4 class="modal-title pull-left">{{'SERVICE-CSV.UPLOAD_SAMPLE_CSV' | translate}}</h4>
              <ntr-csv-upload [modal]=lgModal
                [formatName]="selectedFileFormat!==null?selectedFileFormat['name']:null"
                [hasHeader]="selectedFileFormat!==null?selectedFileFormat['hasHeader']:null"
                [fileFormat]="selectedFileFormat" [serviceId]="service.id" [service]="service"
                [separator]="selectedFileFormat!==null?(selectedFileFormat['separator']?selectedFileFormat['separator']:','):','"
              [mappingObjects]="selectedFileFormat!==null?selectedFileFormat['mappingObjects']:null"></ntr-csv-upload>

            </div>
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="2">
          <a ngbNavLink>
            Tas Import
          </a>
          <ng-template ngbNavContent>
            <div class="tab-pane" id="tab2" [class.active]="selectedFileFormat && selectedFileFormat['fusionImport']">
              <h4 class="modal-title pull-left">{{'SERVICE-FUSION.SETUP-FUSION-IMPORT' | translate}}</h4>
              <app-fusion-file-format [modal]=lgModal [serviceId]="service.id" [fileFormat]="selectedFileFormat"></app-fusion-file-format>
            </div>
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="3">
          <a ngbNavLink>
            API Gateway
          </a>
          <ng-template ngbNavContent>
            <div class="tab-pane" id="tab3" [class.active]="!selectedFileFormat || !selectedFileFormat['fusionImport']">
              <h4 class="modal-title pull-left mb-3">{{'SERVICE-API.SETUP_API' | translate}}</h4>
              <ntr-csv-upload [modal]=lgModal [fetchType]="FetchType.API_GATEWAY"
                [formatName]="selectedFileFormat!==null?selectedFileFormat['name']:null"
                [hasHeader]="selectedFileFormat!==null?selectedFileFormat['hasHeader']:null"
                [fileFormat]="selectedFileFormat" [serviceId]="service.id" [service]="service"
                [separator]="selectedFileFormat!==null?(selectedFileFormat['separator']?selectedFileFormat['separator']:','):null"
                [mappingObjects]="selectedFileFormat!==null?selectedFileFormat['mappingObjects']:null"
                [externalApiGateway]="selectedFileFormat?.['externalApiGateway'] ?? {}">
              </ntr-csv-upload>

            </div>
          </ng-template>
        </ng-container>
      </nav>
      <div [ngbNavOutlet]="nav" class="mt-0"></div>

      <!--              <div class="tab-content">-->
      <!--                <div class="tab-pane" id="tab1" [class.active]="!selectedFileFormat || !selectedFileFormat['fusionImport']">-->
      <!--                    <h4 class="modal-title pull-left">{{'SERVICE-CSV.UPLOAD_SAMPLE_CSV' | translate}}</h4>-->
      <!--                    <ntr-csv-upload [modal]=lgModal -->
      <!--                    [formatName]="selectedFileFormat!==null?selectedFileFormat['name']:null" -->
      <!--                    [hasHeader]="selectedFileFormat!==null?selectedFileFormat['hasHeader']:null" -->
      <!--                    [fileFormat]="selectedFileFormat" [serviceId]="service.id" [service]="service"-->
      <!--                    [separator]="selectedFileFormat!==null?(selectedFileFormat['separator']?selectedFileFormat['separator']:','):','" -->
    <!--                    [mappingObjects]="selectedFileFormat!==null?selectedFileFormat['mappingObjects']:null"></ntr-csv-upload>-->

  <!--                </div>-->
  <!--                <div class="tab-pane" id="tab2" [class.active]="selectedFileFormat && selectedFileFormat['fusionImport']">-->
  <!--                    <h4 class="modal-title pull-left">{{'SERVICE-FUSION.SETUP-FUSION-IMPORT' | translate}}</h4>-->
  <!--                    <app-fusion-file-format [modal]=lgModal [serviceId]="service.id" [fileFormat]="selectedFileFormat"></app-fusion-file-format>-->
<!--                </div>-->
<!--              </div>-->
</div>
</div>
</div>

<ng-template #informationTemplate>
  <div class="modal-body text-center">
    <p>{{errorMessage | translate}}</p>
    <button type="button" class="btn btn-outline-secondary" (click)="closeModalMessage(informationTemplate);">{{'SERVICE-CSV.OK' | translate}}</button>
  </div>
</ng-template>
